import React from 'react';

const ComplementaryInfo = ({ info }) => {
  return (
    <div className='scrollable' style={{ padding: 'var(--spacing-size)', fontSize: 'var(--regular-text-size)', overflowX: 'auto' }}>
      <div style={{ fontSize: 'var(--section-title-text-size)', paddingBottom: 'var(--half-spacing-size)', fontWeight: '700' }}>
        INFO. COMPLEMENTAR
      </div>
      <p>{info ? info : 'Sem Informação Complementar.'}</p>
    </div>
  )
};

export default ComplementaryInfo;
